import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import {
  AtsJobApplicationFilesPageDocument,
  AtsJobApplicationFilesPageFragment,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ApplicationFiles } from './components/ApplicationFiles'
import { DiscTest } from './components/DiscTest'
import { OfferLetter } from './components/OfferLetter'

interface OutletContext {
  application: AtsJobApplicationFilesPageFragment
  isReviewerRole: boolean
}

const JobApplicationFilesPage = () => {
  const { company } = useCurrentSession()
  const { application, isReviewerRole } = useOutletContext<OutletContext>()
  const params = useParams()
  const id = Number(params.application_id)
  const jobPostingId = Number(params.jobId)

  const { data } = useQuery(AtsJobApplicationFilesPageDocument, {
    variables: { companyId: company.id },
  })

  const offerLetterEnabled =
    data?.features.enabledFeatures.nodes.find((node) => node.name === 'ats_offer_letter')
      ?.enabled || false
  const idealDiscEnabled =
    data?.features.enabledFeatures.nodes.find((node) => node.name === 'ats_ideal_disc_integration')
      ?.enabled || false

  if (!application || isReviewerRole) {
    return null
  }

  return (
    <Box gap="s24">
      {idealDiscEnabled && application.assessment && (
        <DiscTest assessment={application.assessment} />
      )}
      {offerLetterEnabled && <OfferLetter applicationId={id} jobPostingId={jobPostingId} />}

      <ApplicationFiles application={application} />
      <Outlet context={{ application }} />
    </Box>
  )
}

export default JobApplicationFilesPage
